import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
    {
        description: 'Motivo de Dispensa de Multa',
        path: '/biblioteca/bibmotivodispensamulta',
        name: 'bibmotivodispensamulta',
        component: () => import('@/views/biblioteca/bibmotivodispensamulta/Index.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_MOTIVODADISPENSADEMULTANOVO_MENU_1300801299],
        },
        goesToMenu: true,
    },
    {
        description: 'Cadastro de Motivo de Dispensa de Multa',
        path: '/biblioteca/bibmotivodispensamulta/cadastro/:id?',
        parent: 'bibmotivodispensamulta',
        name: 'bibmotivodispensamulta_create',
        component: () => import('@/views/biblioteca/bibmotivodispensamulta/InclusaoEdicao.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_MOTIVODADISPENSADEMULTANOVO_MENU_1300801299],
        },
        goesToMenu: true,
    },
]
